import { Directive } from '@angular/core';

@Directive({
    selector: '[veeIframeOnload]',
    standalone: false
})
export class IframeOnloadDirective {

  constructor() { }

}
